<template>
  <div id="div-cover-behind-spinner" v-show="isShowingSpinner">
    <v-progress-circular
      id="fetching-spinner"
      v-show="isShowingSpinner"
      indeterminate
      color="primary"
      :size="100"
      :width="4"
      class="text-xs-center"
    ></v-progress-circular>
  </div>
</template>

<script>
import '../../../style/_variables.scss'
export default {
  name: 'loading-spinner',
  computed: {
    isShowingSpinner: { get () { return this.$store.state.appState.isShowingSpinner } }
  }
}
</script>
<style lang="scss" scoped>
#fetching-spinner {
  z-index: 600;
  top: 40vh;
}
#div-cover-behind-spinner {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
}
#div-cover-behind-spinner {
  z-index: 599;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/utils/LoadingSpinner.vue